<template>
    <div
        class="vue-onboarding__progress"
        :style="{
            'max-width': '100%',
        }">
            <div class="vue-onboarding__progress__percent" :style="{
                width: `${step.value}${step.unit}`
            }"></div>
        </div>
</template>

<script>
export default {
    name: "vue-onboarding-progress",

    props: {
        maxSteps: {
            type: Number,
            default: 0,
        },

        currentStep: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            step: {
                value: 0,
                unit: "%",
            }
        };
    },

    watch: {
        /**
         * Watch the props 'currentStep' change and update calculate step value
         */
        currentStep() {
            this.calculateStep();
        },
    },

    methods: {
        /**
         * Calculate step of onboarding
         */
        calculateStep() {

            if(this.currentStep > this.maxSteps) {
                throw new Error("The maxStep props must not less than currentStep props")
            }

            const ratioStep = (this.currentStep / this.maxSteps) * 100;
            
            this.step.value = ratioStep;
        }
    },

    mounted() {
        this.calculateStep();
    }
};
</script>

<style lang="scss">
.vue-onboarding__progress {
    transition: all 500ms ease;
    height: 8px;
    background: #e9ecef;

    .vue-onboarding__progress__percent {
        height: 100%;
        background: var(--vs-hex-primary);
        transition: all 500ms ease;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingProgress.vue